import { inputTypes } from 'components/common/FormElements/Input'
import { BRAND_COMPATIBILITY_COMPATIBLE, BRAND_COMPATIBILITY_INCOMPATIBLE } from 'constant'
import { COMPATIBILITY_FIELD } from '../constants'

export default {
  compatibility: {
    compatible: {
      label: 'Fits Your Vehicle',
      name: COMPATIBILITY_FIELD,
      type: 'radio',
      value: BRAND_COMPATIBILITY_COMPATIBLE,
      inputType: inputTypes.RADIO_INPUT
    },
    incompatible: {
      label: 'Show Incompatible Tires',
      name: COMPATIBILITY_FIELD,
      type: 'radio',
      value: BRAND_COMPATIBILITY_INCOMPATIBLE,
      inputType: inputTypes.RADIO_INPUT
    }
  }
}
